


















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import WorkerSearchRequest from '@/models/Workers/WorkerSearchRequest';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import PositionDto from '@/models/Positions/PositionDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog'
import ListUtils from '@/lib/listUtils';
import { JobDetailsModule } from '@/store/modules/jobDetails';

@Component({
    name: 'JobBrowseWorkerSearchCriteria'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      if (AgencySettingsModule.skills.length === 0) {
        await AgencySettingsModule.getSkills();
      }
      if (AgencySettingsModule.qualifications.length === 0) {
        await AgencySettingsModule.getQualifications();
      }
    }
  } 

  get workerSearchVM() {
      return JobDetailsModule.workerSearchViewModel;
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get skills() {
    return AgencySettingsModule.skills;
  }

  get qualifications() {
    return AgencySettingsModule.qualifications;
  }

  get distanceOptions() {
    return ListUtils.distanceOptions();
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async reset() {
    
    await JobDetailsModule.resetAdvancedWorkerSearch()
  }

  async search() {
    this.dialog = false;
    await JobDetailsModule.browseAdvancedWorkerSearch()
  }
}
